// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3jNOP","tab":"Tabs_tab__-AwrV","tabActive":"Tabs_tabActive__2qPWd"};